import React from 'react';
import LayoutA from '../LayoutA';

const LayoutD = props => {
  return (
    <LayoutA
      singleColumnWidth={6}
      columnWithItemsWidth={6}
      rowElementsWidth={3}
      availableSlots={13}
      {...props}
    />
  );
};

export default LayoutD;
